import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import type { SxProps } from '@mui/material/styles'

interface IconProps {
  backingSx?: SxProps
  size: number
  sx?: SxProps
}

const IconBacking: React.FC<React.PropsWithChildren<IconProps>> = ({
  backingSx,
  children,
  size,
  sx,
}) => (
  <Stack
    sx={{
      display: 'grid',
      placeItems: 'center',
      zIndex: 3,
      ...sx,
    }}
  >
    {children}

    <Box
      sx={{
        backgroundColor: 'common.white',
        borderRadius: '50%',
        height: size,
        width: size,
        gridRow: 1,
        gridColumn: 1,
        ...backingSx,
      }}
    />
  </Stack>
)

export default IconBacking
